import React from 'react';
import uuid from 'uuid-random';
import { IPosition } from '../../types';
import { StyledColorPicker, StyledColor } from '../Styled';

interface IColorPicker {
  colors: string[];
  chosenColor: string;
  handleColorPick?: (color: string) => void;
  colorPickerPosition?: IPosition;
}

export const ColorPicker: React.FC<IColorPicker> = (props): JSX.Element => {
  const { colors, handleColorPick, chosenColor, colorPickerPosition } = props;

  const handleClick = (color: string) => {
    handleColorPick && handleColorPick(color);
  };

  const onControlKeyDown = (event: React.KeyboardEvent, color: string) => {
    const { key } = event;

    if (key == 'Enter' || key === ' ') {
      handleClick(color);
    }
  };

  return (
    <StyledColorPicker colorPickerPosition={colorPickerPosition} data-testid="color-picker-panel">
      {colors.map(color => {
        return (
          <StyledColor
            data-testid="color-picker-item"
            tabIndex={0}
            isChosen={chosenColor === color}
            key={uuid()}
            color={color}
            onClick={() => handleClick(color)}
            onKeyDown={(event: React.KeyboardEvent) => onControlKeyDown(event, color)}
          />
        );
      })}
    </StyledColorPicker>
  );
};
